// encryption.js

/**
 * @param {string} data - The string to be encrypted.
 * @returns {string} - The encrypted value.
 */
export function encrypt(data) {
    try {
        const encrypted = btoa(data);
        return encrypted;
    } catch (error) {
        console.error("Error encrypting data:", error.message);
        return null;
    }
}
